import React from 'react'
import { inject, observer } from 'mobx-react'
import { withTranslation } from 'react-i18next'
import CostCenterSelect from '../Employees/Form/FormComponents/CostCenterSelect'

const CostCenterSearchField = ({ ordersStore, handleChange }) => {
  return (
    <CostCenterSelect
      id='costCenterSearchField'
      onChange={(costCenter) =>
        handleChange('targetCostcenterId', costCenter ? costCenter.id : null)
      }
      value={ordersStore.targetCostcenterId}
      withSearch
    />
  )
}

export default withTranslation()(
  inject('ordersStore')(observer(CostCenterSearchField))
)
